module.exports = __webpack_public_path__ + "img/que-top.094b8c4c.png";